import InputView from '../../../../FormSteps/InputView'
import RegistrationFormPage from '../Base/RegistrationFormPage'

const RegistrationPage: InputView = ({path}) => (
  <RegistrationFormPage
    path={path}
    requirePassword={true}
    heading='Create your account'
    metaTitle='New HeadBox Business user - HeadBox'
    />
)

export default RegistrationPage
